import React from 'react';
import { Row, Col, Card, CardBody, CardTitle } from 'reactstrap';
import { Link } from 'react-router-dom';

interface SalesChannel {
  title: string;
  bgColor: string;
  iconClass: string;
  description: string;
}

const salesChannels: SalesChannel[] = [
  {
    title: 'In-Store POS',
    bgColor: 'bg-success',
    iconClass: 'mdi-store',
    description: '842',
  },
  {
    title: 'Online Orders',
    bgColor: 'bg-primary',
    iconClass: 'mdi-cart-outline',
    description: '512',
  },
  {
    title: 'Doctor Referrals',
    bgColor: 'bg-warning',
    iconClass: 'mdi-stethoscope',
    description: '112',
  },
];

const SalesChannelsOverview: React.FC = () => {
  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">Sales by Channel</CardTitle>

        <div className="text-center">
          <div className="avatar-sm mx-auto mb-4">
            <span className="avatar-title rounded-circle bg-success-subtle font-size-24">
              <i className="mdi mdi-store text-success"></i>
            </span>
          </div>
          <h5>
            <Link to="#" className="text-dark">
              In-Store POS - <span className="text-muted font-16">842 sales</span>
            </Link>
          </h5>
          <p className="text-muted">
            The majority of sales this week occurred via in-store transactions.
          </p>
          <Link to="#" className="text-primary font-16">
            View full sales report <i className="mdi mdi-chevron-right"></i>
          </Link>
        </div>

        <Row className="mt-4">
          {salesChannels.map((channel, key) => (
            <Col xs={4} key={`_li_${key}`}>
              <div className="text-center mt-3">
                <div className="avatar-xs mx-auto mb-3">
                  <span className={`avatar-title rounded-circle ${channel.bgColor} font-size-16`}>
                    <i className={`mdi ${channel.iconClass} text-white`}></i>
                  </span>
                </div>
                <h5 className="font-size-15">{channel.title}</h5>
                <p className="text-muted mb-0">{channel.description} sales</p>
              </div>
            </Col>
          ))}
        </Row>
      </CardBody>
    </Card>
  );
};

export default SalesChannelsOverview;
